import React, { useEffect, useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const SIDEBAR_WIDTH = 250;
const SIDEBAR_STATE_KEY = "sidebar_open";

export default function MainLayout() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const isMobile = window.innerWidth < 992;

  const [sidebarOpen, setSidebarOpen] = useState<boolean>(() => {
    if (isMobile) return false;
    const saved = localStorage.getItem(SIDEBAR_STATE_KEY);
    return saved ? JSON.parse(saved) : true;
  });

  useEffect(() => {
    if (!isMobile) {
      localStorage.setItem(SIDEBAR_STATE_KEY, JSON.stringify(sidebarOpen));
    }
  }, [sidebarOpen, isMobile]);

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  const handleLogout = () => {
    logout();
    navigate("/", { replace: true });
  };

  return (
    <div className="d-flex">
      {/* Sidebar */}
      <aside
  className="text-white position-fixed h-100 p-3"
  style={{
    backgroundColor: "#0f5132", // verde escuro elegante
    width: SIDEBAR_WIDTH,
    left: sidebarOpen ? 0 : -SIDEBAR_WIDTH,
    top: 0,
    transition: "left 0.3s ease",
    zIndex: 1040,
  }}
>
        <h4 className="text-center mb-4">Menu</h4>

<nav className="flex-grow-1">
  <ul className="nav flex-column">

    <li className="nav-item mb-2">
      <Link className="nav-link text-white opacity-75 hover-opacity-100" to="/dashboard">
        🏠 Início
      </Link>
    </li>

    <li className="nav-item mb-2">
      <Link className="nav-link text-white opacity-75 hover-opacity-100" to="/vendas">
        💰 Vendas
      </Link>
    </li>

    <li className="nav-item mb-2">
      <Link className="nav-link text-white opacity-75 hover-opacity-100" to="/produto">
        📦 Produtos
      </Link>
    </li>

    <li className="nav-item mb-2">
      <Link className="nav-link text-white opacity-75 hover-opacity-100" to="/eventos">
        📅 Eventos
      </Link>
    </li>

    <hr className="border-secondary my-3" />

    <li className="nav-item mb-2">
      <Link className="nav-link text-white opacity-75 hover-opacity-100" to="/equipes">
        👥 Equipes
      </Link>
    </li>

    <li className="nav-item mb-2">
      <Link className="nav-link text-white opacity-75 hover-opacity-100" to="/usuarios">
        👤 Usuários
      </Link>
    </li>

    <hr className="border-secondary my-3" />

    <li className="nav-item mb-2">
      <Link className="nav-link text-white opacity-75 hover-opacity-100" to="/configuracao-impressora">
        🖨️ Impressora
      </Link>
    </li>

  </ul>
</nav>
        <button
          onClick={handleLogout}
          className="btn btn-outline-light mt-auto w-100"
        >
          Sair
        </button>
      </aside>

      {/* Overlay mobile */}
      {sidebarOpen && isMobile && (
        <div
          onClick={() => setSidebarOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.4)",
            zIndex: 1030,
          }}
        />
      )}

      {/* Conteúdo */}
      <div
        className="flex-grow-1"
        style={{
          marginLeft: !isMobile && sidebarOpen ? SIDEBAR_WIDTH : 0,
          transition: "margin-left 0.3s ease",
          minHeight: "100vh",
        }}
      >
        {/* Topbar */}
        <header
          className="d-flex align-items-center justify-content-between px-3"
          style={{
            height: 56,
            backgroundColor: "#ffffff",
            borderBottom: "1px solid #dee2e6",
            position: "sticky",
            top: 0,
            zIndex: 1020,
          }}
        >
          <button
            onClick={toggleSidebar}
            className="btn btn-outline-secondary d-flex align-items-center justify-content-center"
            style={{
              width: 40,
              height: 40,
              fontSize: 20,
            }}
            aria-label="Abrir menu"
          >
            ☰
          </button>

          <span className="fw-semibold">
            Bem-vindo, {user?.nome || "Usuário"}
          </span>
        </header>

        <main className="p-4 bg-light">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
